import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/NotFound.module.css";

export default function NotFound() {
  return (
    <div className={styles.container}>
      <h1>404 - Page Not Found</h1>
      <h2>Wrong Place To Be</h2>

      <p>
        The page you are looking for doesn’t exist or has been moved.
      </p>

      <Link to="/" className={styles.button}>
        Go Back Home
      </Link>
    </div>
  );
}